import * as React from 'react';

let e = React.createElement;

export default class LaunchButton extends React.Component {
  render() {
    let circleChildren = this.props.content;

    if (this.props.icon) {
      circleChildren = e(this.props.icon, {
        svgClass: this.props.svgClass,
        pathClass: this.props.pathClass,
      });
    }

    return (
      <div
        className={
          'launch-button-container' +
          (this.props.className ? ' ' + this.props.className : '')
        }
        onClick={this.props.onClick}
      >
        <div className="launch-button-circle">{circleChildren}</div>
        <span className="launch-button-label" data-testid = {this.props.label}>{this.props.label} </span>
      </div>
    );
  }
}
